import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-150">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="prose prose-lg md:prose-xl mx-auto text-maternal-brown" data-id="element-152">
          <p className="font-heading text-2xl md:text-3xl leading-relaxed italic text-center mb-8 text-maternal-brown/90" data-id="element-153">
            "Estás frente a su puerta cerrada. Otra vez. Tienes ese nudo en el
            estómago porque sabes que cualquier cosa que digas terminará en un
            'no me entiendes' o en un silencio que duele más que un grito."
          </p>

          <div className="w-16 h-1 bg-maternal-amber mx-auto mb-8 rounded-full opacity-50" data-id="element-154"></div>

          <p className="text-lg md:text-xl leading-relaxed text-maternal-lightBrown text-center" data-id="element-155">
            Sientes que el niño dulce que conocías ha sido reemplazado por un
            extraño que te desafía con la mirada. Amas a tu hijo, pero ya no
            sabes cómo hablarle sin que todo termine en una explosión.
          </p>
        </motion.div>
      </div>
    </section>;
}